module.exports = __webpack_public_path__ + "img/10.e0835418.jpg";